import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { getInventoryDetail } from "actions/inventoryAction";
import Inventory from "models/Inventory";

const useGetInventoryDetail = (id, isTrigger = true) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [inventory, setInventory] = useState(new Inventory());

  useEffect(() => {
    const fetch = () => {
      setLoading(true);
      dispatch(getInventoryDetail(id, {
        callbacks: {
          onSuccess: (result) => {
            setInventory(result);
            setLoading(false);
          },
          onFailed: () => {}
        }
      }));
    };

    if (id) {
      fetch();
    }
  }, [id, isTrigger, dispatch]);

  return {
    inventory,
    loading,
    setInventory,
  }
};

export default useGetInventoryDetail;
